import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { errorState } from "./ErrorState";

export const meteoFetch = createSlice({
  name: "meteo",
  initialState: [],
  reducers: {
    add: (state, action) => {
      state.push(action.payload);
    },
    clear: [],
  },
});

export function fetchMeteo(search) {
  return async function (dispatch, getState) {
    try {
      await axios
        .get(
          `https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=3907dbc356b5ded9e522cebe4132825f&units=metric`
        )
        .then((res) => {
          const meteo = res.data;
          dispatch(meteoFetch.actions.add(meteo));
        });
    } catch (error) {
      dispatch(errorState.actions.add(error));
    }
  };
}
